import { useState } from "react";
import "./styles.scss";
//import "./mobile.scss";
import { getInsight } from "../../utils";
import Slider from "react-slick";
import { FiChevronLeft, FiChevronRight } from "react-icons/fi";
import { Button } from "..";

const Index = ({ attachments, file_type }) => {
  const [isLoading, setIsLoading] = useState(false);

  const openWindow = async (fileUrl) => {
    const adUrlRight = process.env.REACT_APP_HOME_TOP_RIGHT_ADV;
    const adUrlLeft = process.env.REACT_APP_HOME_TOP_LEFT_ADV;

    const insight = await getInsight();

    const newWindow = window.open("", "", "width=1024,height=920");
    if (newWindow) {
      const safeAdUrlRight = adUrlRight || "";
      const safeAdUrlLeft = adUrlLeft || "";

      newWindow.document.write(`
        <html>
          <head>
            <title>New Window</title>
            <style>
              body {
                display: flex;
                flex-direction: column;
              }
              .top-ad {
                width: 100%;
                height: 80px;
              }
              .advertiesment-wrapper{
                  display: flex;
                  flex-direction: row;
                  justify-content: center;
                  gap: 10px;
              }
            </style>
          </head>
          <body>
            <div class="advertiesment-wrapper">
              <div class="top-ad">
                <iframe id="adFrameLeft" src="${safeAdUrlLeft}" style="width:100%; height:100%; border:none;" loading="lazy"></iframe>
              </div>
              <div class="top-ad">
                <iframe id="adFrameRight" src="${safeAdUrlRight}" style="width:100%; height:100%; border:none;" loading="lazy"></iframe>
              </div>
            </div>
            
          <iframe src="${fileUrl}" alt="PDF" width="100%" height="100%" />;
            <script>
              window.addEventListener('load', function() {
               const iframeLeft = document.getElementById('adFrameLeft');
                const iframeRight = document.getElementById('adFrameRight');

                iframeLeft?.addEventListener('load', function() {
                  iframeLeft.contentWindow?.postMessage(
                    { insight_id: "${insight?.insight_id || ""}" },
                    "${safeAdUrlLeft}"
                  );
                });

                iframeRight?.addEventListener('load', function() {
                  iframeRight.contentWindow?.postMessage(
                    { insight_id: "${insight?.insight_id || ""}" },
                    "${safeAdUrlRight}"
                  );
                });
                });
              });
            </script>
          </body>
        </html>
      `);
      newWindow.document.close();
    }
  };

  // const openWindow = (fileUrl) => {
  //   const newWindow = window.open("", "", "width=1024,height=920");
  //   if (newWindow) {
  //     newWindow.document.write(`
  //     <html>
  //       <head>
  //         <title>New Window</title>
  //       </head>
  //       <body style="margin:0; padding:0; height:100vh;">
  //       <div>
  //         <div className={"cw__advertiesment-wrapper"}>
  //           <div className="top-ad active">

  //           </div>
  //           <div className="top-ad active">

  //           </div>
  //         </div>
  //         <iframe src="${fileUrl}" alt="PDF" width="100%" height="100%" />
  //       </div>
  //       </body>
  //     </html>
  //   `);
  //     newWindow.document.close();
  //   }
  // };

  // slider
  const [currentSlide, setCurrentSlide] = useState(0);

  const totalSlides = (attachments?.length || 0) + 2; // +2 for "Home" and "Contact us"
  const isFirstSlide = currentSlide === 0;
  const isLastSlide = currentSlide === totalSlides - 1;

  const settings = {
    variableWidth: true,
    className: "slider variable-width",
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 2, //number of items sliding at a time
    initialSlide: 0,
    cssEase: "cubic-bezier(0.33, 1, 0.68, 1)",
    afterChange: (index) => setCurrentSlide(index),
    nextArrow: (
      <div className="rvow__next">
        <Button
          data={{
            buttonIcon: true,
            btnIcon: <FiChevronRight />,
            buttonType: isLastSlide ? "disabled" : "icon",
            buttonSize: "md",
            style: "rvow__next",
          }}
        />
      </div>
    ),

    prevArrow: (
      <div className="rvow__prev">
        <Button
          data={{
            buttonIcon: true,
            btnIcon: <FiChevronLeft />,
            buttonType: isFirstSlide ? "disabled" : "icon",
            buttonSize: "md",
            style: "rvow__prev",
          }}
        />
      </div>
    ),
  };
  // const onClickDownload = async (file_url, file_name) => {
  //   setIsLoading(true);
  //   try {
  //     const response = await fetch(file_url);
  //     const blob = await response.blob();

  //     const url = window.URL.createObjectURL(blob);
  //     const a = document.createElement("a");
  //     a.href = url;
  //     a.download = file_name;
  //     document.body.appendChild(a);
  //     a.click();
  //     a.remove();
  //     window.URL.revokeObjectURL(url);

  //     setIsLoading(false);
  //   } catch (error) {
  //     console.error("Download error:", error);
  //     setIsLoading(false);
  //   }
  // };

  const onClickDownload = (file_url, file_name) => {
    const a = document.createElement("a");
    a.href = file_url;
    a.download = file_name; // this is optional — if omitted, browser uses filename from URL
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
  };

  return (
    <div className="attachment-slider ">

        {attachments.map((file, index) => {
          return (
            <div className="slide-item">
              <div className="file-preview">
                {file_type === "pdf" ? (
                  <iframe width={'100%'} height={'1000px'} src={file?.file_url} title="PDF" />
                ) : (
                  <img
                    className={`img-component`}
                    src={file.url}
                    alt={file.caption}
                  />
                )}
                {file_type === "pdf" && (
                  <div className="hover-overlay">
                    <button onClick={() => openWindow(file?.file_url)}>
                      VIEW
                    </button>
                    <a
                      href={file?.file_url}
                      onClick={() =>
                        onClickDownload(file?.file_url, file?.file_name)
                      }
                    >
                      DOWNLOAD
                    </a>
                  </div>
                )}{" "}
              </div>
            </div>
          );
        })}
    </div>
  );
};

export default Index;
